import { CurrencyPipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';

@Component({
  selector: 'app-bounty-pill',
  templateUrl: './bounty-pill.component.html',
  styleUrls: ['./bounty-pill.component.scss'],
})
export class BountyPillComponent {
  @Input({ required: true }) amount!: number;
  @Input() size: 'extra-small' | 'small' | 'medium' | 'large' = 'small';

  private currencyPipe = inject(CurrencyPipe);

  get pillStyles(): [string, string][] {
    return [
      ['background', 'pill-bounty'],
      ['border', 'pill-bounty'],
      ['drop-shadow', 'pill-bounty'],
      ['border-radius', 'pill-bounty'],
    ];
  }

  get plusStyle(): [string, string][] {
    return [['text-color', 'pill-bounty-label']];
  }

  get labelStyles(): [string, string][] {
    return [
      ['type', `pill-bounty-${this.size}-label`],
      ['text-color', `pill-bounty-label`],
    ];
  }

  // TODO: refactor this to support MCN and other currencies once operator is enabled
  get formattedAmount(): string {
    if (this.amount === undefined) return '';
    const formattedValue =
      this.amount < 1
        ? `${Math.round(this.amount * 100)}¢`
        : this.currencyPipe.transform(
            this.amount,
            'USD',
            'symbol',
            this.amount % 1 === 0 ? '1.0-0' : '1.0-2',
          );

    return formattedValue ?? '';
  }
}
